import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { A11y, Navigation, EffectFade, Thumbs, FreeMode } from 'swiper/modules'
import 'swiper/scss/effect-fade'
import { MenuItemType } from '@utils/types'
import { WContainer, EditableTitle } from '@components/atoms'
import { TimelineCard } from '@components/molecules'
import styles from './TimelineSection.module.sass'
import { handleTimelineTracking } from '@utils/tracking'

interface Props {
  item: MenuItemType
  editMode?: boolean
  className?: string
}

const TimelineSection = (props: Props) => {
  const { item = undefined, editMode = false, className = '' } = props

  const [mainSwiper, setMainSwiper] = useState(null)
  const [thumbsSwiper, setThumbsSwiper] = useState(null)
  const [activeIndex, setActiveIndex] = useState(0)

  // Get the current card (slide)
  const currentCard = item?.children?.[activeIndex]

  const HandleSlideKeyDown = (e: React.KeyboardEvent<HTMLElement>, index: number) => {
    if (e.key !== 'Enter' && e.key !== ' ') return
    mainSwiper?.slideTo(index)
  }

  return item ? (
    <div className={`${styles.root} ${editMode ? styles['root--editMode'] : ''} ${className}`}>
      <WContainer>
        <div className={`${styles.layout}`}>
          {!!item.name && (
            <EditableTitle title={item.name} className={styles.title} editMode={editMode} />
          )}
          {editMode ? (
            <>{item.children}</>
          ) : (
            !!item.children?.length && (
              <>
                <div className={`${styles.slider}`}>
                  <Swiper
                    slidesPerView={1}
                    spaceBetween={24}
                    modules={[A11y, Navigation, EffectFade, Thumbs]}
                    effect="fade"
                    speed={640}
                    fadeEffect={{
                      crossFade: true,
                    }}
                    navigation
                    className={`swiper--white ${
                      !currentCard?.name ? styles['slider--no-title'] : ''
                    }`}
                    thumbs={{ swiper: thumbsSwiper }}
                    onSwiper={setMainSwiper}
                    onNavigationNext={(swiper) => {
                      setActiveIndex(swiper.activeIndex)
                      handleTimelineTracking(item.children[swiper.activeIndex].name, 'slider')
                    }}
                    onNavigationPrev={(swiper) => {
                      setActiveIndex(swiper.activeIndex)
                      handleTimelineTracking(item.children[swiper.activeIndex].name, 'slider')
                    }}
                  >
                    {item.children.map((x) => (
                      <SwiperSlide key={x.pk}>
                        <TimelineCard item={x} className={styles.item} />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
                <div className={`${styles.thumbs}`}>
                  <Swiper
                    onSwiper={setThumbsSwiper}
                    spaceBetween={24}
                    slidesPerView={'auto'}
                    freeMode
                    watchSlidesProgress
                    modules={[A11y, Navigation, FreeMode, Thumbs]}
                    className="swiper--white"
                    onTap={(swiper) => {
                      setActiveIndex(swiper.clickedIndex)
                      handleTimelineTracking(item.children[swiper.clickedIndex].name, 'click')
                    }}
                  >
                    {item.children.map((x, index) => (
                      <SwiperSlide
                        key={x.pk}
                        tag={'button'}
                        onKeyDown={(e) => HandleSlideKeyDown(e, index)}
                      >
                        <div className={styles.thumb}>{x.name || x.intro}</div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </>
            )
          )}
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default TimelineSection
